import { createSlice } from '@reduxjs/toolkit';
import {
  Checkout,
  UserCartCreation,
  UserClearCart,
  UserGetCart,
  UserGetSingleCart,
  UserMajorCartCreation,
  UserRemoveCart,
} from './cartServicesSync';

export const userCartSlice = createSlice({
  name: 'user_cart',
  initialState: {
    cart_loader: false,
    cart_all_loader: false,
    checkout_loader: false,
    clear_cart_loader: false,
    message: '',
    cart: {},
    cartDetails: {},
    cartIndicator: '',
    cartRemoveIndicator: '',
  },
  reducers: {
    clearState: (state) => {
      state.cart_loader = false;
      state.cart_all_loader = false;
      state.checkout_loader = false;
      state.clear_cart_loader = false;
      state.message = '';
      state.cart = {};
      state.cartDetails = {};
      state.cartIndicator = '';
      state.cartRemoveIndicator = '';

      return state;
    },

    updateCartIndicator: (state, { payload }) => {
      state.cartIndicator = payload;
    },

    updateCartRemoveIndicator: (state, { payload }) => {
      state.cartRemoveIndicator = payload;
    },

    updateCartDetails: (state, { payload }) => {
      state.cartDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserCartCreation.pending, (state) => {
        state.cart_loader = true;
      })
      .addCase(UserCartCreation.fulfilled, (state, { payload }) => {
        state.cartDetails = payload?.data?.products[payload?.cartIndex];

        state.cart_loader = false;
        state.message = payload?.message;
      })
      .addCase(UserCartCreation.rejected, (state, { payload }) => {
        state.cart_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserMajorCartCreation.pending, (state) => {
        state.cart_loader = true;
      })
      .addCase(UserMajorCartCreation.fulfilled, (state, { payload }) => {
        state.cart = payload?.data;

        state.cart_loader = false;
        state.message = payload?.message;

        state.cartIndicator = '';
      })
      .addCase(UserMajorCartCreation.rejected, (state, { payload }) => {
        state.cart_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserGetCart.pending, (state) => {
        state.cart_all_loader = true;
      })
      .addCase(UserGetCart.fulfilled, (state, { payload }) => {
        state.cart_all_loader = false;
        state.message = payload?.message;
        state.cart = payload?.data;
      })
      .addCase(UserGetCart.rejected, (state, { payload }) => {
        state.cart_all_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserGetSingleCart.pending, (state) => {
        state.cart_loader = true;
      })
      .addCase(UserGetSingleCart.fulfilled, (state, { payload }) => {
        state.cart_loader = false;
        state.message = payload?.message;
        state.cartDetails = payload?.data;
      })
      .addCase(UserGetSingleCart.rejected, (state, { payload }) => {
        state.cart_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserClearCart.pending, (state) => {
        state.clear_cart_loader = true;
      })
      .addCase(UserClearCart.fulfilled, (state, { payload }) => {
        state.clear_cart_loader = false;
        state.message = payload?.message;

        state.cart = null;
      })
      .addCase(UserClearCart.rejected, (state, { payload }) => {
        state.clear_cart_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(UserRemoveCart.pending, (state) => {
        state.cart_loader = true;
      })
      .addCase(UserRemoveCart.fulfilled, (state, { payload }) => {
        state.cart = payload?.data;

        state.cart_loader = false;
        state.message = payload?.message;

        state.cartRemoveIndicator = '';
      })
      .addCase(UserRemoveCart.rejected, (state, { payload }) => {
        state.cart_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(Checkout.pending, (state) => {
        state.checkout_loader = true;
      })
      .addCase(Checkout.fulfilled, (state, { payload }) => {
        state.checkout_loader = false;
        state.message = payload?.message;
      })
      .addCase(Checkout.rejected, (state, { payload }) => {
        state.checkout_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  clearState,
  updateCartIndicator,
  updateCartRemoveIndicator,
  updateCartDetails,
} = userCartSlice.actions;
export const cartSelector = (state) => state.user_cart;

export default userCartSlice.reducer;
